import api from "@/api/axiosApi";
import handleHttpError from "@/util/HttpErrorHandler";

const API_URL = `/objective`;

// Récupérer tous les objectifs utilisateurs
export const allUserObjective = async () => {
  try {
    const response = await api.get(API_URL);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Impossible de récupérer les objectifs.");
    return [];
  }
};

// Enregistrer un objectif utilisateur
export const saveUserObjective = async (userObjective) => {
  try {
    const response = await api.post(API_URL, userObjective);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de l'enregistrement de l'objectif.");
    throw error;
  }
};

// Supprimer un objectif utilisateur
export const deleteUserObjective = async (objectiveId) => {
  const url = `${API_URL}/${objectiveId}`;
  try {
    await api.delete(url);
  } catch (error) {
    handleHttpError(error, "Erreur lors de la suppression de l'objectif.");
    throw error;
  }
};

// Récupérer les objectifs par hiérarchie
export const getUserObjectivesByHierarchique = async (userId, status, page, size) => {
  const url = `${API_URL}/hierarchique`;
  try {
    const response = await api.get(url, {
      params: { userId, status, page, size }
    });
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des objectifs hiérarchiques.");
    throw error;
  }
};

// Récupérer tous les objectifs utilisateur avec filtres
export const getUserObjectivesAll = async (page, size, userId, status, year,filter,disabled, idServices,idDirections,idToll) => {
  const url = `${API_URL}/user-objectives-all`;
const statusParam = status.join(',')
  
  try {  
     
    const response = await api.get(url, {
      params: { page, size, userId, status: statusParam, year,search: filter,disabled, idServices,idDirections,idToll }
    });
    

    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des objectifs utilisateurs.");
    throw error;
  }
};

// Récupérer tous les objectifs utilisateur à exporter
export const getUserObjectivesAllToExport = async (page, size, userId, status, year,filter,disabled, idServices,idDirections,idToll) => {
  const url = `${API_URL}/user-objectives-all`;
const statusParam = status.join(',')

  try {

    const response = await api.get(url, {
      params: { page, size, userId, status: statusParam, year,search: filter,disabled, idServices,idDirections,idToll }
    });


    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des objectifs utilisateurs.");
    throw error;
  }
};

// Récupérer un objectif utilisateur par ID
export const getIdUserObjective = async (objectiveId,usersId) => {
  const url = `${API_URL}/${objectiveId}/${usersId}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération de l'objectif.");
    throw error;
  }
};

// Récupérer les objectifs utilisateur par année
export const  getUserObjectivesByYears = async (usersId,year) => {
  const url = `${API_URL}/years/${usersId}/${year}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération des objectifs par année.");
    throw error;
  }
};

// Mettre à jour un objectif utilisateur
export const updateUserObjective = async (objectiveId, userId, userObjectiveData) => {
  const url = `${API_URL}/${objectiveId}/${userId}`;
  try {
    const response = await api.put(url, userObjectiveData);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la mise à jour de l'objectif.");
    throw error;
  }
};

// Mettre à jour la validation d'un objectif utilisateur
export const updateValidObjectif = async (objectiveId, userId, userObjectiveData) => {
  const url = `${API_URL}/valid/${objectiveId}/${userId}`;
  try {
    const response = await api.put(url, userObjectiveData);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la mise à jour de la validation de l'objectif.");
    throw error;
  }
};

// Mettre à jour la date d'un objectif utilisateur
export const updateDateUserObjective = async (objectiveId, userId, userObjectiveData) => {
  const url = `${API_URL}/date/${objectiveId}/${userId}`;
  try {
    const response = await api.put(url, userObjectiveData);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la mise à jour de la date de l'objectif.");
    throw error;
  }
};
export const getCountByStatusAndYearsByObjectif = async (years) => {
  const url = `${API_URL}/dashboard/${years}`;
  try {
    const response = await api.get(url);
    return response.data;
  } catch (error) {
    handleHttpError(error, "Erreur lors de la récupération de l'utilisateur.");
    throw error;
  }

};
export const updateDateObjectiveStatus =async (objectiveId,userId,userObjectiveData)=> {
  const url = `${API_URL}/update-status/${objectiveId}/${userId}`;
  try {
    const response = await api.put(url, userObjectiveData);
    return response.data;
  }catch (error) {
    handleHttpError(error, "Erreur lors de la modification du statut de l'objectif.");
    throw error;
  }

}